import React from 'react';
import Notification from './components/UI/Notification/Notification';
import useScrollMemory from './hooks/useScrollMemory';
import Routes from './Routes';

function App() {
    useScrollMemory();

    return (
        <div className="App">
            <Routes />
            <Notification />
        </div>
    );
}

export default App;
